import * as z from "zod";
import { recordConnectorUsage, usageRef } from "../connectorUsages";
import { mutator } from "./mutator";

export const createAuditLogDestinationSchema = z.object({
  id: z.string(),
  name: z.string().min(1),
  url: z.string().url().startsWith("https://"),
  method: z.enum(["PUT", "POST"]),
  connectedAppId: z.string().nullable().optional(),
});

export const createAuditLogDestination = mutator({
  schema: createAuditLogDestinationSchema,
  resolve: {
    app: {
      kind: "connectedApp",
      from: "connectedAppId",
      optional: true,
    },
  },
  permissions: [
    {
      permission: "tenant:audit_logs_manage",
      scopeId: ({ ctx }) => ctx.tenantId,
    },
    {
      permission: "connected_app:use",
      scopeId: ({ args }) => args.app?.id ?? null,
    },
  ],
  fn: async ({ tx, ctx, args: { id, name, url, method, app } }) => {
    await tx.mutate.auditLogDestinations.insert({
      id,
      name,
      url,
      method,
      cursorTimestamp: Date.now(),
      lastError: null,
      tenantId: ctx.tenantId,
    });
    if (app) {
      await recordConnectorUsage(
        tx,
        app.id,
        usageRef.auditLogDestination(id),
        ctx.tenantId
      );
    }
  },
});
